export const routes = (parentName) => {
  return [
    {
      path: "manual-payments",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-ManualPayments`,
          component: () => import("./List.vue"),
          props: (route) => ({
            status: route.query.status,
          }),
        },
        {
          path: ":id",
          name: parentName + "-" + "ManualPayments-View",
          component: () => import("./View.vue"),
        },
      ],
    },
  ];
};
